import { useCallback } from 'react';
import { ACCESS_LEVELS, useRequiresRateShopperAccessLevel } from '../../../../hooks/use-has-rate-shopper-access-level';

import { Segment } from '../../../../services/analytics-services/segment';

import {
  RATE_SHOPPER_CREATE_NEW,
  RATE_SHOPPER_DELETE,
  RATE_SHOPPER_EXPAND,
  RATE_SHOPPER_MANAGE_CLICK,
  RATE_SHOPPER_SAVE,
  RATE_SHOPPER_TOGGLE_ACTIVATE,
  RATE_SHOPPER_TOGGLE_DEACTIVATE,
  RATE_SHOPPER_UPSELL_MODAL_OPEN,
  RATE_SHOPPER_USE_TEMPLATE,
} from '../../../../constants/analytics-events';

export const SettingsPageEvents = {
  RATE_SHOPPER_CREATE_NEW,
  RATE_SHOPPER_DELETE,
  RATE_SHOPPER_EXPAND,
  RATE_SHOPPER_SAVE,
  RATE_SHOPPER_TOGGLE_ACTIVATE,
  RATE_SHOPPER_TOGGLE_DEACTIVATE,
  RATE_SHOPPER_UPSELL_MODAL_OPEN,
  RATE_SHOPPER_USE_TEMPLATE,
};

export const CswEvents = {
  RATE_SHOPPER_MANAGE_CLICK,
};

export const useTrackRateShopperEvent = (eventName, data) => {
  const hasPremiumAccess = useRequiresRateShopperAccessLevel(ACCESS_LEVELS.PREMIUM);
  const accessLevel = hasPremiumAccess ? ACCESS_LEVELS.PREMIUM : ACCESS_LEVELS.FREEMIUM;

  return useCallback(() => {
    const payload = {
      accessLevel,
      ...data,
    };

    Segment.trackEvent(eventName, payload);
  }, [accessLevel, data, eventName]);
};
